import axios from 'axios';
import config from '../config';

async function request(method, path, data) {
  try {
    const response = await axios({ method, url: `${config.api4BaseUrl}/users${path}`,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }, data });
    return response.data;
  } catch (error) {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('token');
      window.location.assign('/login');
    }
    throw error;
  }
}
export function userError(error) {
  const body = error.response && error.response.data;
  if (error.response && error.response.status === 403) return 'You do not have permission to manage users.';
  if (error.response && error.response.status === 429) return 'Too many password attempts. Wait a minute and try again.';
  if (body && body.message) return body.message;
  if (body && body.errors) return Object.values(body.errors).flat().join(' ');
  return 'Unable to save or load the account. Please try again.';
}
export default {
  me: () => request('get', '/me'),
  list: () => request('get', ''),
  create: data => request('post', '', data),
  update: (id, data) => request('put', `/${id}`, data),
  setPassword: (id, data) => request('post', `/${id}/password`, data),
  changePassword: data => request('post', '/me/password', data)
};
